const MONTHS = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

export function formatDate(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateTime(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${h}:${m}`;
}

export function formatRelative(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  const diffH   = Math.floor(diffMs / 3600000);
  const diffD   = Math.floor(diffMs / 86400000);

  if (diffMin < 1)  return 'hace un momento';
  if (diffMin < 60) return `hace ${diffMin} min`;
  if (diffH < 24)   return `hace ${diffH} ${diffH === 1 ? 'hora' : 'horas'}`;
  if (diffD < 7)    return `hace ${diffD} ${diffD === 1 ? 'día' : 'días'}`;
  return formatDate(isoString);
}

export function isOverdue(dueDateString) {
  if (!dueDateString) return false;
  return new Date(dueDateString) < new Date(new Date().toDateString());
}

export function daysUntilLabel(dueDateString) {
  if (!dueDateString) return null;
  const due  = new Date(dueDateString);
  const now  = new Date(new Date().toDateString());
  const diff = Math.round((due - now) / 86400000);
  if (diff < 0)  return `Venció hace ${Math.abs(diff)} ${Math.abs(diff) === 1 ? 'día' : 'días'}`;
  if (diff === 0) return 'Hoy';
  if (diff === 1) return 'Mañana';
  if (diff <= 14) return `En ${diff} días`;
  return formatDate(dueDateString);
}
